import { getTranslatedText } from "../../../../utils/getTranslatedText";
import Modal from "../../../modal/Modal";

import CheckSvgComponent from "../CheckSvgComponent";
import { useGetTranslatedText } from "../queries";

import styles from "./styles.module.scss";

const FeedbackComponent = (props) => {
  const {show} = props;

  const languageid = localStorage.getItem("l_id") || 1;
    
  const {data:translatedTextResponse} = useGetTranslatedText(languageid)
              
  const {data:translatedText = []} = translatedTextResponse || {};

  return (
    <>
      <Modal visible={show}>
        <div className={styles["assessment-wrapper"]}>
          <CheckSvgComponent />
          <div className={styles.title}>{getTranslatedText(translatedText,"key_thanks_feedback", "Thanks for feedback")}</div>
          <div className={styles.description}>
            {getTranslatedText(translatedText , "key_feedback_value","Your feedback is valuable to us.")}
          </div>
          {/* <div className={styles["button-wrapper"]}>
             <Button
              label="Go to course"
              buttonVariant={BUTTON_VARIANTS.PRIMARY}
              onClick={handleGoToCourse}
              className={styles.button}
            />
          </div> */}
        </div>
      </Modal>
    </>
  );
};

export default FeedbackComponent;
